import React, { Component } from 'react';
import Hero from "../modules/Hero/Hero";
import ImagePanel from "../modules/ImagePanel";
import RegisterBlock from "../modules/RegisterBlock";
import globals from '../globals';
import HelmetDefault from "../layout/HelmetDefault";

class NetworkSolutions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            imagePanel2: {},
            imagePanel3: {},
            seoTitle: '',
            seoDescription: '',
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/network-solutions/overview')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <ImagePanel
                    data={this.state.imagePanel2}
                    align="left"
                    className="image2"
                />
                <ImagePanel
                    data={this.state.imagePanel3}
                    align="right"
                    className="image3"
                    hasWave={true}
                />
                <RegisterBlock />
            </div>
        );
    }

}

export default NetworkSolutions;


// WEBPACK FOOTER //
// ./resources/assets/js/networkSolutions/NetworkSolutions.js